import {
  Component, OnInit, EventEmitter, Injector,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { FormGroup, FormControl} from '@angular/forms';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { OTranslateService } from '../../services';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_SEARCH_INPUT = [
  'placeholder'
];

export const DEFAULT_OUTPUTS_O_SEARCH_INPUT = [
  'onSearch'
];


export class OSearchInputComponent implements OnInit {

  public static DEFAULT_INPUTS_O_SEARCH_INPUT = DEFAULT_INPUTS_O_SEARCH_INPUT;
  public static DEFAULT_OUTPUTS_O_SEARCH_INPUT = DEFAULT_OUTPUTS_O_SEARCH_INPUT;

  protected placeholder: string = 'SEARCH';

  onSearch: EventEmitter<any> = new EventEmitter<any>();

  protected formGroup: FormGroup;
  protected term: FormControl;
  protected value: string = '';

  protected translateService: OTranslateService;

  constructor(protected injector: Injector) {
    this.translateService = this.injector.get(OTranslateService);

    this.formGroup = new FormGroup({});
  }

  ngOnInit() {
    this.term = new FormControl();
    this.formGroup.addControl('term', this.term);

    this.term.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe(term => {
        this.onSearch.emit(term);
      });
  }

  getFormGroup(): FormGroup {
    return this.formGroup;
  }

  getValue(): string {
    return this.value;
  }

  get placeHolder(): string {
    if (this.translateService) {
      return this.translateService.get(this.placeholder);
    }
    return this.placeholder;
  }

  set placeHolder(value: string) {
    var self = this;
    window.setTimeout(() => {
      self.placeholder = value;
    }, 0);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-search-input',
  template: `
    <form #innerForm [formGroup]="getFormGroup()" fxFill>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFill fxLayoutAlign="space-between center">
            <span class="icon-btn"><i class="material-icons">search</i></span>
            <md-form-field>
                <input mdInput class="mat-input" #term type="search" id="term" fxFill [placeholder]="placeHolder" formControlName="term">
            </md-form-field>
        </div>
    </form>
  `,
  styles: [`
    .o-search{position:relative;height:30px}.o-search>.mat-icon{position:absolute;top:0.15em;left:0.3em;color:inherit}.o-search-input{height:25px;width:80%;font-size:15px;border:1px solid inherit;border-radius:20px;padding-left:30px}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_SEARCH_INPUT
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_SEARCH_INPUT
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
];
}


export class OSearchInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OSearchInputComponent],
  imports: [OSharedModule, CommonModule],
  exports: [OSearchInputComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
